import { render, staticRenderFns } from "./FilterTodos.vue?vue&type=template&id=231f1ca0&"
import script from "./FilterTodos.vue?vue&type=script&lang=js&"
export * from "./FilterTodos.vue?vue&type=script&lang=js&"
import style0 from "./FilterTodos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports